if (navigator.userAgent.match('MSIE') || navigator.userAgent.match('Trident')) {
    document.write(`
    <p>
        このページはInternet Explorerには対応していません。<br>
        他のブラウザをご利用ください。
    </p>
    <p>
        This page does not support Internet Explorer.<br>
        Please use another browser.
    </p>
    `);
    throw Error('Using IE.');
}

export enum Method {
    check = 0,
    sign = 1,
}

type HouseInfo = {
    id: number;
    name: Translation;
    limit_encoding?: string;
    tsandcs: Translation;
    greeting: Translation;
    agreement_method: Method;
};

type ReserveInfo = {
    id: number;
    room_count: number;
    checkin: string;
    checkout: string;
    canceled: boolean;
};

export type ReservesRoom = {
    id: number;
    start_time: string;
    end_time: string;
    name: string | Translation;
    ssid: string | null;
    wifi_password: string | null;
    lockstate_pin: string;
    lockstate_qr: string;
};

type BillingItem = {
    default_tax_percent: number;
    default_include_tax: boolean;
};

import {
    Option,
    Schedule,
    TextProperty,
    LocaleText,
    UserDefinedItem,
} from '../common/merchandise/Types';
export type MerchandiseItem = {
    id: number;
    house_id: number;
    billing_item_id: number;
    category: string;
    sales_unit: 'quantity_unit' | 'time_unit';
    arrange: number;
    unit_price: number;
    sales_start_time: string | null;
    sales_end_time: string | null;
    merchandise_recommendation: MerchandiseRecommendation;
    image_urls: string[];
    stock?: number;
    need_seat_selection?: number;
    for_sale: number;
    user_defined_pulldown:
        | (UserDefinedItem & { id: number; options: Option[] })
        | null;
    user_defined_textarea: (UserDefinedItem & { id: number }) | null;
    use_dates: UseDate[];
    texts: Record<TextProperty, LocaleText>;
    limit_unit: number;
    billing_item: BillingItem;
    plan_matched_reserves_room_ids: number[];
    amountIncludingTax: () => number;
};

export type UseDate = {
    date: string;
    start_time?: string;
    end_time?: string;
    schedules?: Schedule[];
};

type MerchandiseRecommendation = {
    is_general: number;
    valid: number;
};

import Vue from 'vue';
import Component from 'vue-class-component';
import QueryControlComponent from '../common/QueryControl.vue';
import ApiClient from '../common/ApiClient';
const api = new ApiClient('/register/api/');
const hash = location.pathname.match(/\/register\/([^\/]+)/)?.[1];

console.log('Environment', Environment);
if (Environment == 'production') {
    Vue.config.productionTip = false;
    Vue.config.devtools = false;
}

Vue.filter('price', function (val: number) {
    if (typeof val != 'number') return val || '-';
    if (val == Infinity || isNaN(val)) return '-';
    const num = Math.round(val || 0);
    return '￥' + num.toLocaleString();
});

import { MobileOrderCart } from './MoblieOrderCart';

import Top from './Top.vue';
import Menu from './Menu.vue';
import House from './House.vue';
import Guest from './Guest.vue';
import GuestInformation from './GuestInformation.vue';
import GratuityList from './GratuityList.vue';
import GratuityDetail from './GratuityDetail.vue';
import GratuityConfirm from './GratuityConfirm.vue';
import Billing from './Billing.vue';
import BillingBreakdown from './BillingBreakdown.vue';
import Code from './Code.vue';
import LockstateQr from './LockstateQr.vue';
import Checkout from './Checkout.vue';
import Agreement from './Agreement.vue';
import Terminal from './Terminal.vue';
import MerchandiseCategories from './MerchandiseCategories.vue';
import MerchandiseList from './MerchandiseList.vue';
import MerchandiseDetail from './MerchandiseDetail.vue';
import MobileOrdered from './MobileOrdered.vue';
import MobileOrderApplication from './MobileOrderApplication.vue';
import IssueReceipt from './IssueReceipt.vue';
export const components = {
    Top,
    Menu,
    House,
    Guest,
    GuestInformation,
    GratuityList,
    GratuityDetail,
    GratuityConfirm,
    Billing,
    BillingBreakdown,
    Code,
    LockstateQr,
    Checkout,
    Agreement,
    Terminal,
    MerchandiseCategories,
    MerchandiseList,
    MerchandiseDetail,
    MobileOrdered,
    MobileOrderApplication,
    IssueReceipt,
};
type Lang = 'ja' | 'en' | 'cn' | 'ko';

import template from './app.vue.html';
import { ConsumptionTax } from '../common/ConsumptionTax';
import {
    GratuityTexts,
    GratuityStaff,
    GratuityStaffTexts,
} from '../common/gratuity/Types';
import { registerServiceWorker } from '../libs/WorkerSetup';
@Component({ template, components })
export default class App extends QueryControlComponent {
    service_name: string = 'HOTEL SMART';
    translations: { [key: string]: Translation } = {};
    house: HouseInfo | null = null;
    stripe: {
        unpaid: number;
        modified: string;
        only_cancellation_fee: boolean;
    } | null = null;
    reserve: ReserveInfo | null = null;
    guestList: GuestInfo[] = [];
    code: string | null = null;
    checkin_qrcode: string | null = null;
    reserves_rooms: ReservesRoom[] = [];
    lockstate_display_reserves_rooms: ReservesRoom | null = null;
    require_agreement: boolean = false;
    display_house_info: number = 0;
    house_guide_url: string = '';
    display_reserve_info: boolean = false;
    display_checkout_button: boolean = true;
    display_time_of_stay_dates: boolean = true;
    downloadable_invoice: boolean = false;
    agreement_tsandcs_url: string | null = null;
    checkedin: boolean = false;
    checkedout: boolean = false;
    line: {
        add_friends_url: string;
        appeal_text: string;
        appeal_image_url: string;
        banner_image_url: string;
    } | null = null;
    mapApiKey = '';
    days_before_checkout_payment_allowed: number | null = null;
    start_time_of_payment_allowed: string | null = null;
    addressee_options: { guest_name: string; company_name: string | null } = {
        guest_name: '',
        company_name: null,
    };
    invoice_amount: number | null = null;
    unpaid: Bill[] = [];

    mobile_order_merchandises: MerchandiseItem[] = [];
    enabled_mobile_order: boolean = false;

    private loaded_gratuity_staff_image_mappings: {
        image_urls: string[];
        gratuity_staff_id: number;
    }[] = [];
    enabled_gratuity: boolean = false;
    mobile_ordered_count: number = 0;
    gratuity_orders_count: number = 0;
    seat_name: string = '';
    seat_names: Record<string, string> = {};
    last_seat_name: { category: string; seat_name: string } = {
        category: '',
        seat_name: '',
    };
    gratuity!: {
        id: number;
        texts: GratuityTexts;
        default_amount: number;
        max_amount: number;
        staffs: GratuityStaff[];
        is_billing_item_id: boolean;
    };
    cart: MobileOrderCart | null = null;
    gratuity_staffs: any;

    showMobileOrder() {
        return (
            this.mobile_ordered_count ||
            (this.enabled_mobile_order &&
                this.mobile_order_merchandises.length &&
                this.reserve?.room_count)
        );
    }

    showGratuity() {
        return (
            this.showMobileOrder() &&
            this.enabled_gratuity &&
            this.gratuity.staffs.length > 0 &&
            this.gratuity.is_billing_item_id
        );
    }

    error: string = '';
    page: keyof typeof components = 'Top';

    get lockstateQrExist(): boolean {
        return Boolean(this.getReservesRoomsWithLockstateQr().length);
    }

    forceUpdate() {
        this.$forceUpdate();
        this.$children.forEach((c) => c.$forceUpdate());
    }

    getLang(): Lang | null {
        const id = this.reserve?.id;
        if (!id) return null;
        if (['ja', 'en', 'cn', 'ko'].includes(this.query.lang ?? '')) {
            this.setLang(this.query.lang as Lang);
        }
        return (localStorage?.getItem('Mypage:Language:' + id) as Lang) || null;
    }

    setLang(lang: Lang | null) {
        const id = this.reserve?.id;
        if (id) {
            if (lang) localStorage?.setItem('Mypage:Language:' + id, lang);
            else localStorage.removeItem('Mypage:Language:' + id);
        }
        if (lang == 'cn') {
            document.documentElement.lang = 'zh-CN';
        } else {
            document.documentElement.lang = lang ?? '';
        }
        this.forceUpdate();
    }

    async post(path: string, obj: { [k: string]: any } = {}): Promise<any> {
        obj.hash = hash;
        const res = await api.post(path, obj);
        if (res.warning)
            console.warn('Server Api Response Warning.', res.warning);
        return res;
    }

    getLocaleText(
        tgt: string | Translation,
        ...vars: (string | number)[]
    ): string {
        if (!tgt) return '';
        const lang = this.getLang() || 'ja';
        let tns: Translation;
        if (typeof tgt == 'string') {
            tns = this.translations[tgt];
            if (!tns) return tgt;
        } else {
            tns = tgt;
        }

        let str = tns[lang] || '';
        vars.forEach((rep, i) => (str = str.replace(`{${i}}`, String(rep))));
        return str;
    }

    async created() {
        try {
            const initial = !(await ReserveStorage.get('InitialAccess'));
            const r = await this.post('base-info', { initial });
            if (!r.succeed) {
                this.error = r.error || 'Connection Error';
                return;
            }
            if (initial) {
                await ReserveStorage.set(
                    'InitialAccess',
                    new Date().toISOString()
                );
            }
            this.service_name = r.service_name;
            this.translations = r.translations;
            this.mapApiKey = r.mapApiKey;
            this.house = r.house;
            this.reserve = r.reserve;
            this.display_house_info = r.display_house_info;
            this.display_reserve_info = r.display_reserve_info;
            this.display_checkout_button = r.display_checkout_button;
            this.display_time_of_stay_dates = r.display_time_of_stay_dates;
            this.downloadable_invoice = r.downloadable_invoice;
            this.house_guide_url = r.house_guide_url;
            this.agreement_tsandcs_url = r.agreement_tsandcs_url;
            this.days_before_checkout_payment_allowed =
                r.days_before_checkout_payment_allowed;
            this.start_time_of_payment_allowed =
                r.start_time_of_payment_allowed;
            this.gratuity = r.gratuity;

            this.line = r.line;

            this.mobile_order_merchandises = r.mobile_order_merchandises.map(
                (
                    item: Omit<MerchandiseItem, 'amountIncludingTax'>
                ): MerchandiseItem => ({
                    ...item,
                    amountIncludingTax: function () {
                        return new ConsumptionTax({
                            amount: this.unit_price,
                            include_tax: this.billing_item.default_include_tax,
                            tax_percent: this.billing_item.default_tax_percent,
                        }).amountIncludingTax;
                    },
                })
            );
            this.enabled_mobile_order = r.enabled_mobile_order;
            const gratuity_staffs = r.gratuity.staffs as Omit<
                GratuityStaff,
                'image_urls'
            >[];
            await this.loadGratuityImageMappingsFrom(
                gratuity_staffs.map(({ id }) => id)
            );
            this.gratuity_staffs = gratuity_staffs.map(
                (item): GratuityStaff => ({
                    ...item,
                    image_urls:
                        this.gratuity.staffs.find(({ id }) => id === item.id)
                            ?.image_urls ?? [],
                })
            );
            this.enabled_gratuity = r.enabled_gratuity;

            super.created();
            if (!this.getLang()) return;
            await this.fetchInfo();
            if (!this.query.page) {
                if (this.reserve?.canceled) {
                    this.setPage('Billing');
                } else {
                    this.setPage(this.code ? 'Terminal' : 'Menu');
                }
            }
        } catch (err) {
            console.error(err);
            this.error =
                err instanceof Error ? err.message : 'Connection Error';
        }
    }
    setPage(page: keyof typeof components): void {
        const allowedPagesForCanceled = ['Billing', 'IssueReceipt'];
        if (this.reserve?.canceled && !allowedPagesForCanceled.includes(page)) {
            this.error = 'Reservation is not found.';
            return;
        }

        this.updateQuery({ page });
    }
    load(): void {
        const page = this.query.page as keyof typeof components;

        const allowedPagesForCanceled = ['Billing', 'IssueReceipt'];
        if (this.reserve?.canceled && !allowedPagesForCanceled.includes(page)) {
            this.error = 'Reservation is not found.';
            return;
        }

        if (page in components) this.page = page;
    }

    async fetchInfo(): Promise<void> {
        if (this._currentFetch) return this._currentFetch;
        const fetch = this._fetchInfo().finally(
            () => (this._currentFetch = null)
        );
        return (this._currentFetch = fetch);
    }

    private _currentFetch: Promise<void> | null = null;
    private async _fetchInfo() {
        try {
            const r = await this.post('global-info');
            if (!r.succeed) throw new Error(r.error);

            this.stripe = r.stripe;
            this.guestList = r.guestList;
            this.code = r.code;
            this.checkin_qrcode = r.checkin_qrcode;
            this.reserves_rooms = r.reserves_rooms;
            this.require_agreement = r.require_agreement;
            this.checkedin = r.checkedin;
            this.checkedout = r.checkedout;
            this.invoice_amount = r.invoice_amount;
            this.addressee_options = r.addressee_options;

            this.mobile_order_merchandises = r.mobile_order_merchandises.map(
                (
                    item: Omit<MerchandiseItem, 'amountIncludingTax'>
                ): MerchandiseItem => ({
                    ...item,
                    amountIncludingTax: function () {
                        return new ConsumptionTax({
                            amount: this.unit_price,
                            include_tax: this.billing_item.default_include_tax,
                            tax_percent: this.billing_item.default_tax_percent,
                        }).amountIncludingTax;
                    },
                })
            );
            this.mobile_ordered_count = r.mobile_ordered_count;

            this.cart = this.reserve
                ? new MobileOrderCart(
                      this.reserve.id,
                      this.mobile_order_merchandises
                  )
                : null;
            this.seat_name = r.seat_name;
            this.seat_names = r.seat_names;
            this.last_seat_name = r.last_seat_name;
        } catch (err) {
            console.error(err);
            const msg = err instanceof Error ? err.message : String(err);
            alert(msg || 'Connection Error');
        }
    }

    private async loadGratuityImageMappingsFrom(itemIds: number[]) {
        const itemIdsUnloadingImage = itemIds.filter((itemId) =>
            this.loaded_gratuity_staff_image_mappings.every(
                ({ gratuity_staff_id: loaded_item_id }) =>
                    loaded_item_id !== itemId
            )
        );
        const responses = await Promise.all(
            itemIdsUnloadingImage.map((itemId) =>
                this.post('load-gratuity-image-urls', {
                    id: itemId,
                })
            )
        );
        if (responses.some((res) => !res.succeed)) {
            throw new Error('Failed to fetch gratuity staff images.');
        }

        this.loaded_gratuity_staff_image_mappings =
            this.loaded_gratuity_staff_image_mappings.concat(
                responses.map((res) => ({
                    image_urls: res.image_urls,
                    gratuity_staff_id: res.gratuity_staff_id,
                }))
            );
    }

    async fetchMerchandises(): Promise<void> {
        try {
            const response = await this.post('load-merchandises');
            if (!response.succeed) throw new Error(response.error);
            this.reserves_rooms = response.reserves_rooms;
            this.mobile_order_merchandises =
                response.mobile_order_merchandises.map(
                    (
                        item: Omit<MerchandiseItem, 'amountIncludingTax'>
                    ): MerchandiseItem => ({
                        ...item,
                        amountIncludingTax: function () {
                            return new ConsumptionTax({
                                amount: this.unit_price,
                                include_tax:
                                    this.billing_item.default_include_tax,
                                tax_percent:
                                    this.billing_item.default_tax_percent,
                            }).amountIncludingTax;
                        },
                    })
                );
            this.mobile_ordered_count = response.mobile_ordered_count;
            this.cart = this.reserve
                ? new MobileOrderCart(
                      this.reserve.id,
                      this.mobile_order_merchandises
                  )
                : null;
        } catch (error) {
            const msg = error instanceof Error ? error.message : String(error);
            alert(msg || 'Connection Error');
        }
    }

    async fetchGratuities(): Promise<void> {
        try {
            const response = await this.post('load-gratuities');
            if (!response.succeed) throw new Error(response.error);
            this.reserves_rooms = response.reserves_rooms;
            this.gratuity_orders_count = response.gratuity_orders_count;
            this.gratuity_staffs = (response.gratuity_staffs ?? []).map(
                (item: GratuityStaff): GratuityStaff => ({
                    ...item,
                    image_urls:
                        this.loaded_gratuity_staff_image_mappings.find(
                            ({ gratuity_staff_id }) =>
                                gratuity_staff_id === item.id
                        )?.image_urls ?? [],
                })
            );
        } catch (error) {
            const msg = error instanceof Error ? error.message : String(error);
            alert(msg || 'Connection Error');
        }
    }

    getReservesRoomsWithLockstateQr(): ReservesRoom[] {
        return this.reserves_rooms.filter((reserves_room) => {
            return reserves_room.lockstate_qr;
        });
    }

    openHouseInfo(): void {
        if (this.display_house_info === 2) {
            window.open(this.house_guide_url);
            return;
        }
        if (this.display_house_info || this.display_reserve_info) {
            this.setPage('House');
            return;
        }
    }
}

document.addEventListener(
    'DOMContentLoaded',
    () => {
        const main = document.createElement('main');
        document.body.appendChild(main);
        const app = new App({ el: main });
        Object.defineProperty(self, 'app', { value: app });
        registerServiceWorker();
    },
    { once: true }
);

class ReserveStorage {
    static async hash() {
        const key = location.pathname.match(/\/register\/([^\/]+)/)?.[1];
        if (!key) return null;
        const keyBuffer = await new Blob([key]).arrayBuffer();
        const hash = await crypto.subtle.digest('SHA-1', keyBuffer);
        return btoa(String.fromCharCode(...new Uint8Array(hash)));
    }

    static async get(key: string): Promise<string | null> {
        if (!localStorage) return null;
        const hash = await ReserveStorage.hash();
        if (!hash) return null;
        return localStorage.getItem(`Mypage:${key}:${hash}`) ?? null;
    }

    static async set(key: string, value: string): Promise<void> {
        if (!localStorage) return;
        const hash = await ReserveStorage.hash();
        if (!hash) return;
        localStorage.setItem(`Mypage:${key}:${hash}`, value);
    }
}
